<template>
  <RatioSpacedContainer
    class="h-full overflow-auto"
    :top="4"
    :bottom="6"
  >
    <div class="w-full">
      <AuthForm
        class="px-4 mx-auto py-10"
        @done="onAuthDone"
      />

      <div class="mt-6 text-center">
        <span>{{ _t('auth.no_account') }}</span>
        <TextButton
          class="register-btn"
          :label="_t('auth.wx_register')"
          @click="onWxRegister"
        />
      </div>
    </div>
  </RatioSpacedContainer>
</template>

<script lang="ts" setup>
import type { UserInfo } from '@/api/auth'
import AuthForm from '@/components/AuthForm/AuthForm.vue'
import { useCopy } from '@/hooks'
import { afterLogin } from '@/shared/landing'
import { useCommonStore } from '@/stores/common-store'
import { openWechatApp } from '@/utils/wechat'
import { useRoute, useRouter } from 'vue-router'

// query:
//  - redirect?: redirect url

const store = useCommonStore()
const route = useRoute()
const router = useRouter()

const copy = useCopy()

async function onAuthDone(token: string, user: UserInfo) {
  store.login(token, user)
  afterLogin(router, route)
}

function onWxRegister() {
  _notice({
    scene: 'wechat',
    okText: _t('common.wx_tip1'),
    content: _t('common.wx_tip2'),
    onConfirm() {
      copy(_t('common.wx_tip3'))

      openWechatApp()
    },
  })
}
</script>

<style scoped></style>
